import React, { useState, useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import { callMsGraph } from "../utils/msGraphApiCall";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [graphData, setGraphData] = useState(null);
  const navigate = useNavigate();
  console.log("GraphData", graphData);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
      return;
    }

    const getProfile = async () => {
      if (accounts[0]) {
        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
          const data = await callMsGraph(response.accessToken);
          setGraphData(data);
        } catch (error) {
          console.error("Error fetching profile:", error);
        }
      }
    };
    getProfile();
  }, [instance, accounts, isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="container">
      <h5 className="card-title">Welcome {accounts[0] && accounts[0].name}</h5>
      {graphData ? (
        <div>
          <p className="card-text">Name: {graphData.displayName}</p>
          <p className="card-text">
            Email: {graphData.mail || graphData.userPrincipalName}
          </p>
        </div>
      ) : (
        <p className="card-text">Loading profile...</p>
      )}
      <button className="btn btn-primary" onClick={() => navigate("/")}>
        Back to Home
      </button>
    </div>
  );
}
